import * as React from 'react'
import moment from 'moment'
import { Subtract } from 'utility-types'

type CounterProps = {
    to: number
}

type InjectedProps = {
    days?: number
    hours: number
    minutes: number
    seconds: number
}

type State = {
    timer?: number
    days: number
    hours: number
    minutes: number
    seconds: number
}

const makeCountdown = <P extends InjectedProps>(Component: React.ComponentType<P>) => {
    type ParentProps = Subtract<P, InjectedProps> & CounterProps

    return class MakeCountdown extends React.Component<
        ParentProps,
        State
    > {
        readonly state: State = {
            days: 0,
            hours: 0,
            minutes: 0,
            seconds: 0,
        }

        constructor(props: ParentProps) {
            super(props)

            this.tick = this.tick.bind(this)
        }

        componentDidMount() {
            this.tick()

            this.setState({
                timer: window.setInterval(this.tick, 1000),
            })
        }

        componentWillUnmount() {
            window.clearInterval(this.state.timer)
        }

        tick() {
            const now = moment()
            const target = moment.unix(this.props.to)
            const diff = moment.duration(target.diff(now))

            this.setState({
                days: diff.asDays(),
                hours: Math.floor(diff.asHours()),
                minutes: diff.minutes(),
                seconds: diff.seconds(),
            })
        }

        render() {
            const { to, ...props } = this.props
            let { days, hours, minutes, seconds } = this.state

            days = Math.floor(Math.max(days, 0))
            hours = Math.max(hours, 0)
            minutes = Math.max(minutes, 0)
            seconds = Math.max(seconds, 0)

            return (
                <Component
                    {...props as unknown as P}
                    days={days}
                    hours={hours}
                    minutes={minutes}
                    seconds={seconds}
                />
            )
        }
    }
}

export default makeCountdown
